<template>
	<div class="flex flex_between">
		<md-field :class="[{ 'md-error': error }]">
			<label>{{ $t("common.assignmentType") }}</label>
			<TbSelect v-model="moduleValue"
					  @md-selected="onSelect"
					  options-value-field="value"
					  options-display-field="displayValue"
					  :options="options"
					  :disabled="isDisabled"
					  :required="required"
			/>
			<span v-if="error" class="validation-error">{{ error }}</span>
		</md-field>
	</div>
</template>
<script>
import {enumDef} from "src/common/enumDefs";
import {isValueSet} from "@/common/format";

export default {
	props: {
		error: { type: String, default: "" },
		required: { type: Boolean, default: false },
		value: { type: Boolean, default: null },
		receivableType: { type: Number, default: null },
		assignmentTypeFromDsr: { type: Boolean, default: null }
	},
	data() {
		return {
			moduleValue: null,
			isValueEnforcedByReceivableType: false
		};
	},
	computed: {
		options() {
			return [
				{
					value: enumDef.disclosedType.Undisclosed,
					displayValue: this.$t(enumDef.disclosedType.properties[enumDef.disclosedType.Undisclosed].key)
				},
				{
					value: enumDef.disclosedType.Disclosed,
					displayValue: this.$t(enumDef.disclosedType.properties[enumDef.disclosedType.Disclosed].key)
				}
			]
		},
		isDisabled() {
			if (this.isValueEnforcedByReceivableType) {
				return true;
			}

			let auctionDisclosedSetting = this.$sessionStorage.get("localeUser").auctionDisclosed;

			// If value is not equal to the setting we need allow the user to change it
			if (isValueSet(this.assignmentTypeFromDsr)) {
				return this.assignmentTypeFromDsr === this.value;
			}
			return auctionDisclosedSetting != null && auctionDisclosedSetting === this.value;
		}
	},
	mounted() {
		this.updateModuleValue(this.value);
	},
	methods: {
		updateModuleValue(value) {
			this.enforceValueByReceivableType();

			if (!this.isValueEnforcedByReceivableType) {
				this.moduleValue = value;
			}
		},
		onSelect(val) {
			this.$emit("input", val);
		},
		enforceValueByReceivableType() {
			if (isValueSet(this.receivableType) && this.receivableType === enumDef.receivableType.InstallmentContractRate) {
				this.moduleValue = enumDef.disclosedType.Disclosed;
				this.isValueEnforcedByReceivableType = true;

				this.$emit("input", this.moduleValue);
			} else {
				this.isValueEnforcedByReceivableType = false;
			}
		}
	},
	watch: {
		value() {
			this.updateModuleValue(this.value);
		}
	}
};
</script>
